export const API_URL = process.env.REACT_APP_APIURL || "";
export const APP_NAME = process.env.REACT_APP_NAME || "";

export const PROD = process.env.REACT_APP_CONTEXT === "PROD";

export const months_long_se = [ "Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December" ];
export const months_short_se = [ "Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec" ];

export const weekdays_long_se = [ "Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag" ];
export const weekdays_short_se = [ "Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör" ];

export const multiselectOverrideStrings = {
    selectSomeItems: "Välj...",
    allItemsAreSelected: "Alla val är markerade.",
    selectAll: "Välj alla",
    search: "Sök",
    clearSearch: "Töm Sök"
}

export const grades = [ "A", "B", "C", "D", "E", "F" ];
export const gradeObjects = {
    "A": {
        meritValue: 20,
        failed: false
    },
    "B": {
        meritValue: 17.5, 
        failed:false
    }, 
    "C": {
        meritValue: 15,
        failed:false
    }, "D": {
        meritValue: 12.5,
        failed:false
    }, 
    "E": {
        meritValue: 10,
        failed:false
    }, 
    "F": {
        meritValue: 0,
        failed:true
    }
};

export const yearGradeOptions_GR =[
    { value: 1, label: 'Årskurs 1'},
    { value: 2, label: 'Årskurs 2'},
    { value: 3, label: 'Årskurs 3'},
    { value: 4, label: 'Årskurs 4'},
    { value: 5, label: 'Årskurs 5'},
    { value: 6, label: 'Årskurs 6'},
    { value: 7, label: 'Årskurs 7'},
    { value: 8, label: 'Årskurs 8'},
    { value: 9, label: 'Årskurs 9'},
];

export const yearGradeOptions_GY =[
    { value: 11, label: '1a ring'},
    { value: 12, label: '2a ring'},
    { value: 13, label: '3e ring'}
];

export const yearGradeOptions = [
    ...yearGradeOptions_GR,
    ...yearGradeOptions_GY
];

export const yearGradeOptions_GR_str =[
    { value: "1", label: 'Årskurs 1'},
    { value: "2", label: 'Årskurs 2'},
    { value: "3", label: 'Årskurs 3'},
    { value: "4", label: 'Årskurs 4'},
    { value: "5", label: 'Årskurs 5'},
    { value: "6", label: 'Årskurs 6'},
    { value: "7", label: 'Årskurs 7'},
    { value: "8", label: 'Årskurs 8'},
    { value: "9", label: 'Årskurs 9'},
];

export const yearGradeOptions_GY_str =[
    { value: "G1", label: '1a ring'},
    { value: "G2", label: '2a ring'},
    { value: "G3", label: '3e ring'}
];

export const yearGradeOptions_str = [
    ...yearGradeOptions_GR_str,
    ...yearGradeOptions_GY_str
];

export const defaultGRCourses = [
    { courseCode: 'EN', displayName: 'Engelska' },
    { courseCode: 'MA', displayName: 'Matematik' },
    { courseCode: 'SV', displayName: 'Svenska' },
    { courseCode: 'SVA', displayName: 'Svenska som andraspråk' },
    { courseCode: 'BL', displayName: 'Bild' },
    { courseCode: 'BI', displayName: 'Biologi' },
    { courseCode: 'FY', displayName: 'Fysik' },
    { courseCode: 'GE', displayName: 'Geografi' },
    { courseCode: 'HKK', displayName: 'Hem- och Konsumentkunskap' },
    { courseCode: 'HI', displayName: 'Historia' },
    { courseCode: 'IDH', displayName: 'Idrott och hälsa' },
    { courseCode: 'KE', displayName: 'Kemi' },
    { courseCode: 'M2FRA', displayName: 'Moderna språk, Franska' },
    { courseCode: 'M2SPA', displayName: 'Moderna språk, Spanska' },
    { courseCode: 'M2DEU', displayName: 'Moderna språk, Tyska' },
    { courseCode: 'MU', displayName: 'Musik' },
    { courseCode: 'NO', displayName: 'NO-ämne' },
    { courseCode: 'RE', displayName: 'Religionskunskap' },
    { courseCode: 'SH', displayName: 'Samhällskunskap' },
    { courseCode: 'SL', displayName: 'Slöjd' },
    { courseCode: 'SO', displayName: 'SO-ämne' },
    { courseCode: 'TK', displayName: 'Teknik' }
]